/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GlobalFacade } from '~app/app/~store/facades/global.facade';
import { Observable, map } from 'rxjs';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';

@Component({
  selector: 'settings-wrapper',
  templateUrl: './settings-wrapper.component.html',
  styleUrls: ['./settings-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsWrapperComponent {
  authFacade = inject(AuthFacade);
  headerTitle$ = this.globalFacade.routeData$.pipe(
    map(routeData =>
      routeData
        ? (routeData.data?.headerSubtitle as string | undefined)
        : undefined
    )
  );

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  constructor(
    private globalFacade: GlobalFacade,
    private breakpointObserver: BreakpointObserver
  ) {}

  currentUser$ = this.authFacade.currentUser$;
  isAdmin$: Observable<boolean> = this.currentUser$.pipe(
    map(user => user?.isAdmin ?? false)
  );
}
